var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserPermission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2a2 2 0 012 2v5.706a.667.667 0 11-1.333 0V7.333H3.333V16c0 .349.27.639.617.665l.05.002h5.234a.667.667 0 110 1.333H4a2 2 0 01-2-2V4a2 2 0 012-2h12zm-1.832 7.667c1.403 0 2.134.937 2.166 2.361A2 2 0 0118 14v2a2 2 0 01-2 2h-3.333a2 2 0 01-2-2v-2A2 2 0 0112 12.114c.016-1.497.731-2.447 2.168-2.447zM16 13.333h-3.333A.667.667 0 0012 14v2c0 .368.298.667.667.667H16a.667.667 0 00.667-.667v-2a.667.667 0 00-.667-.667zm-8.476-.666a.667.667 0 110 1.333h-2.19a.667.667 0 110-1.333h2.19zM14.168 11c-.573 0-.803.263-.832 1H15c-.023-.719-.265-1-.832-1zm-3.835-1.667a.667.667 0 110 1.334h-5a.667.667 0 010-1.334h5zm5.667-6H4A.667.667 0 003.333 4v2h13.334V4a.667.667 0 00-.617-.665L16 3.333z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPermission);
export default __webpack_public_path__ + "static/assets/userPermission.7e5ae954.svg";
export { ForwardRef as ReactComponent };